import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons'

import {css} from '@emotion/react'
import Modal from './Modal.jsx'

const cssBody = css({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    overflow: 'inherit',
})

const cssIcon = css({
    fontSize: 24,
    marginRight: 12,
})

const cssIconError = css({
    color: '#ff4d4f',
})

const cssIconInfo = css({
    color: '#1890ff',
})

const cssIconOk = css({
    color: '#52c41a',
})

const cssIconWarn = css({
    color: '#faad14',
})

const cssContent = css({
    display: 'grid',
    alignSelf: 'stretch',
    overflow: 'hidden',
})

export default function Alert({children, type, ...props}) {
    const icon = {
        error: <CloseCircleOutlined css={[cssIcon, cssIconError]} />,
        info: <InfoCircleOutlined css={[cssIcon, cssIconInfo]} />,
        ok: <CheckCircleOutlined css={[cssIcon, cssIconOk]} />,
        warn: <ExclamationCircleOutlined css={[cssIcon, cssIconWarn]} />,
    }[type] ?? <div></div>

    return (
        <Modal
            cancelText="关闭"
            title="提示"
            okButtonProps={{style: {display: 'none'}}}
            {...props}
        >
            <div css={cssBody}>
                {icon ?? <div></div>}
                <div css={cssContent}>{children}</div>
            </div>
        </Modal>
    )
}
